module.exports = __webpack_public_path__ + "static/media/placeholder.50383745.png";